import { HierarchyContextProps, IHierarchyActionSetHierarchyId } from "../interface";

/**
 * Updates the active hierarchy identifier.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-id action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchyId = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetHierarchyId,
): HierarchyContextProps => ({
  ...state,
  id: action.hierarchyId,
});
